import { Flame } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { writeErrorLog } from '@lib/logger/logError.ts';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import useContactsApi from '../../../features/contacts/hooks/useContactsApi.ts';
import { paintToast } from '@lib/logger/paintToast.ts';
import { LogLevels } from '@types';

interface FuegoLeadProps {
  contactId: string;
  contactName: string;
   fuegoLead: boolean;
   onFuegoLeadChange?: (value: boolean) => void;
}

const FuegoLead: React.FC<FuegoLeadProps> = ({
  contactId,
  contactName,
  fuegoLead,
  onFuegoLeadChange }) => {
  const { t } = useTranslation();
  const { updateContactFuegoLeadAsync } = useContactsApi();
  const [localFuegoLead, setLocalFuegoLead] = useState(fuegoLead);

  useEffect(() => {
    setLocalFuegoLead(fuegoLead);
  }, [fuegoLead]);

  const handleFuegoLeadChange = async (nextFuegoLead: boolean): Promise<void> => {
    const prevfuegoLead = localFuegoLead;
    setLocalFuegoLead(nextFuegoLead);

    if (contactId === null) {
      return;
    }

    try {
      await updateContactFuegoLeadAsync(contactId, nextFuegoLead);
      onFuegoLeadChange?.(nextFuegoLead);

    } catch (e) {
      setLocalFuegoLead(prevfuegoLead);
      await writeErrorLog(t('dialer.contact.errorUpdateFuegoLead', { lng: 'en' }), 'FuegoLead.handleFuegoLeadChange', {});
      paintToast(LogLevels.ERROR, t('dialer.contact.errorUpdateFuegoLead'));
    }
  };

  return (
    <div className="flex items-center md:col-span-2">
      <button
        type="button"
        onClick={() => {
          void handleFuegoLeadChange(!localFuegoLead);
        }}
        className={clsx(
          'flex items-center gap-2 px-3 py-1.5 rounded-full border transition-all duration-200 cursor-pointer',
          localFuegoLead
            ? 'bg-orange-500/15 border-orange-500/40 text-orange-600 dark:text-orange-400'
            : 'bg-transparent border-border text-muted-foreground hover:border-orange-500/30 hover:text-orange-500'
        )}
      >
        <Flame className={clsx(
          'size-4 md:size-5 shrink-0 transition-colors duration-200',
          localFuegoLead ? 'fill-current' : 'fill-none'
        )} />
        <span className="text-xs md:text-sm font-medium">
          Fuego Lead
        </span>
      </button>
    </div>
  );
};

export default FuegoLead;
